import { bizTransaction } from '@/common/service/ApiList';
import {updateToast, insertToast, removeToast, customToast} from '@/common/utils/ToastServiceResult';
import { assist } from '@/common/utils/ParameterAssistant';

import ServiceExec from '@/common/utils/ServiceExec';

const { getList, detail} = bizTransaction;

const actions = {
  FETCH_LIST: async ({ commit, state }, page) => {
    const { condition } = state;
    commit('setCondition', assist(condition, page));

    const { status, data } = await ServiceExec.get(getList, condition);
    if (status === 200) {
      const { list, pageInfo } = data;
      commit('setList', list ?? []);
      commit('setPageInfo', pageInfo ?? {});
    }
  },
  FETCH_DETAIL: async ({ commit, state }, bizRequestNo) => {
    const { status, data } = await ServiceExec.get(detail(bizRequestNo));
    if (status === 200) commit('setDetail', data);

    commit('setDetail', data)
  },

};
export default actions;

